import { StockResearchAdvicesAction } from './stock-research-advices.action';

export class StockResearchAdivcesState {
    advices: any;
    advice: any;
    pending: boolean;
    error: null;
}

export const initialGenericState: StockResearchAdivcesState = {
    advices: '',
    advice: '',
    pending: false,
    error: null
}

export function StockResearchAdivcesReducer(state: StockResearchAdivcesState = initialGenericState, action: any){

    switch (action.type) {

        case StockResearchAdvicesAction.getAdvices:
            return { ...{}, ...state, ...{ pending: true, error: null } };
        case StockResearchAdvicesAction.getAdvicesSuccess:
            return { ...{}, ...state, ...{ pending: false, error: null, advices: action.payload } };
        case StockResearchAdvicesAction.getAdvicesError:
            return { ...{}, ...state, ...{ pending: false, error: action.payload } };
        case StockResearchAdvicesAction.cleanAdvice:
            return { ...{}, ...state, ...{ advice: null } };

        case StockResearchAdvicesAction.getAdvice:
            return { ...{}, ...state, ...{ pending: true, error: null } };
        case StockResearchAdvicesAction.getAdviceSuccess:
            return { ...{}, ...state, ...{ pending: false, error: null, advice: action.payload } };
        case StockResearchAdvicesAction.getAdviceError:
            return { ...{}, ...state, ...{ pending: false, error: action.payload } };
        case StockResearchAdvicesAction.adviceNotFound:
            return { ...{}, ...state, ...{ pending: false, error: null, advice: null } };   
        case StockResearchAdvicesAction.cleanAdvices:
            return { ...{}, ...state, ...{ advices: [] } };

        default:
            return state;
    }

}